module.exports = __webpack_public_path__ + "static/media/clinic-medical.635ad20c.svg";